import HTTP from '../libs/HTTP';


export interface CustomerListRequest {
    pageNo: number;
    pageSize: number;
}

//query接口返回参数
export interface ICustomerInfoList {
    records: ICustomerInfo[];
    total: number;
    size: number;
    current: number;
    pages: number;
}
export interface ICustomerInfo {
    id: number;
    company: number;
    cname: string;
    ename?: string | null;
    gender?: number | null;
    mobile?: string | null;
    phone?: string | null;
    wechat?: string | null;
    email?: string | null;
    position?: string | null;
    department?: string | null;
    fax?: string | null;
    keyCustomer: boolean;
    remark?: string | null;
    states: number;
    lastEditTime: number;
}

//add接口请求参数
export interface AddCustomerParam {
    company: number;
    cname: string;
    ename?: string | null;
    gender?: number | null;
    mobile?: string | null;
    phone?: string | null;
    wechat?: string | null;
    email?: string | null;
    position?: string | null;
    department?: string | null;
    fax?: string | null;
    keyCustomer: boolean;
    remark?: string | null;
    states: number;
}

//edit接口请求参数
export interface EditCustomerParam {
    id: number| null;
    company?: number | null;
    cname?: string | null;
    ename?: string | null;
    gender?: number | null;
    mobile?: string | null;
    phone?: string | null;
    wechat?: string | null;
    email?: string | null;
    position?: string | null;
    department?: string | null;
    fax?: string | null;
    keyCustomer?: boolean;
    remark?: string | null;
    states?: number;
}

//文件导入接口请求参数
export interface ImportCustomerRequest {
    file: File;
}
//文件导入接口返回参数
export interface ImportCustomerRes {
    insert: number;
    update: number;
    fail: number;
    skip: number;
    message: String;
}

class CustomerService extends HTTP {
    //查询指定公司客户信息
    async getCustomerByCompanyId(id: number, request: CustomerListRequest) {
        const response = await this.get(`/customer/getCustomerByCompanyId/${id}`, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //查询指定客户信息
    async getCustomerById(id: number) {
        const response = await this.get(`/customer/getCustomerById/${id}`);
        if (response) {
            return response.data;
        }
    }

    //添加客户
    async addCustomer(request: AddCustomerParam) {
        const response = await this.post('/customer/addCustomer', request, {
            params: {
                company: request.company,
                cname: request.cname,
                ename: request.ename,
                gender: request.gender,
                mobile: request.mobile,
                phone: request.phone,
                wechat: request.wechat,
                email: request.email,
                position: request.position,
                department: request.department,
                fax: request.fax,
                keyCustomer: request.keyCustomer,
                remark: request.remark,
                states: request.states,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //编辑客户信息
    async updateCustomer(request: EditCustomerParam) {
        const response = await this.put(`/customer/updateCustomer/${request.id}`, request, {
            params: {
                company: request.company,
                cname: request.cname,
                ename: request.ename,
                gender: request.gender,
                mobile: request.mobile,
                phone: request.phone,
                wechat: request.wechat,
                email: request.email,
                position: request.position,
                department: request.department,
                fax: request.fax,
                keyCustomer: request.keyCustomer,
                remark: request.remark,
                states: request.states,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //删除客户信息
    async deleteCustomer(id: number) {
        const response = await this.delete(`/customer/${id}`);
        if (response) {
            return response.data;
        }
    }

    //导入客户信息
    async importCustomer(request: ImportCustomerRequest) {
        const formData = new FormData();
        formData.append('file', request.file);
        const response = await this.post('/customer/importCustomer', formData, {
            headers: {
                'Content-Type': 'multipart/form-data;', 
            },
        });
        if (response) {
            return response.data;
        }
    }

}
export default new CustomerService();
